import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://placeholder.supabase.co'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'placeholder-key'

// Only create client if we have real environment variables
export const supabase = (process.env.REACT_APP_SUPABASE_URL && process.env.REACT_APP_SUPABASE_ANON_KEY)
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null

// Helper to check if Supabase is available
export const isSupabaseAvailable = !!(process.env.REACT_APP_SUPABASE_URL && process.env.REACT_APP_SUPABASE_ANON_KEY)

// Database types for TypeScript
export interface DatabasePlayer {
  id: string
  name: string
  is_active: boolean
  created_at: string
  updated_at: string
}

export interface DatabasePayment {
  id: string
  player_id: string
  category_id: string
  amount: number
  is_paid: boolean
  paid_at?: string
  is_advance: boolean
  is_partial_payment?: boolean
  created_at: string
  updated_at: string
}

export interface DatabaseExpense {
  id: string
  description: string
  amount: number
  paid_by: string
  category_id: string
  details?: string
  bill_image_url?: string
  created_at: string
  updated_at: string
}

export interface DatabaseConfig {
  id: number
  tournament_fee: number
  transport_total: number
  team_name: string
  updated_at: string
}